import { Component, input } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';
import { RolloutProgressReportEntities } from '../../../../service/entities';

@Component({
  selector: 'app-report-info-item',
  imports: [GcTextComponent, IpoTranslatePipe],
  template: `
    <div class="container" style="display: flex; flex-direction: column;">
      <gc-text [variant]="'bodyBold'">{{ data().label | translate }}</gc-text>
      <gc-text>
        @for (value of data().values; track $index) {
          @if ($index + 1 < data().values.length) {
            {{ (value | translate) + ', ' }}
          } @else {
            {{ value | translate }}
          }
        }
      </gc-text>
    </div>
  `,
})
export class ReportInfoItemComponent {
  data = input.required<RolloutProgressReportEntities.v3.ReportInfoItem>();
}
